
/* eslint-disable @typescript-eslint/camelcase */
import { jobsEventBus } from "@/store/modules/Jobs/jobs-event-bus";
import CircleInfoIcon from "@/components/Icons/CircleInfo.vue";
import XIcon from "@/components/Icons/XIcon.vue";
import { defineComponent, onMounted, onUnmounted, ref } from "vue";
import { Modal } from "bootstrap";
import { useStore } from "vuex";
import { fireSwal } from "@/components/jobs/Misc/helpers";
import Swal from "sweetalert2";

interface WorkerBusyModalProps {
  conflicting_shift: {
    id: number;
    job_id: number;
    job_name: string;
    label: string;
  };
  bookAnywayPayload: undefined | object;
}

export default defineComponent({
  name: "WorkerBusyModal",
  components: { CircleInfoIcon, XIcon },
  setup() {
    const element = ref<HTMLElement | null>(null);
    const modal = ref<Modal | null>(null);
    const payload = ref<WorkerBusyModalProps | null>(null);
    const loading = ref<boolean>(false);
    const store = useStore();

    function setLoading(value: boolean): void {
      loading.value = value;
    }

    const toggleModal = (show: boolean): void => {
      if (modal.value) {
        show ? modal.value.show() : modal.value.hide();
      }
    };

    const clearState = (): void => {
      payload.value = null;
    };

    const eventHandler = (data: WorkerBusyModalProps): void => {
      payload.value = data;
      toggleModal(true);
    };

    const handleBookAnyway = (): void => {
      if (payload.value?.bookAnywayPayload) {
        setLoading(true);
        store
          .dispatch("JobModule/bookUser", {
            ...payload.value.bookAnywayPayload,
            book_anyway: true
          })
          .then((): void => {
            fireSwal();
            clearState();
            setLoading(false);
            toggleModal(false);
          })
          .catch((): void => {
            setLoading(false);
            Swal.fire({
              title: "There was an error",
              toast: true,
              position: "top-right",
              showConfirmButton: false,
              icon: "error",
              timer: 800
            });
          });
      }
    };

    onMounted((): void => {
      element.value = document.getElementById("worker_busy_modal");
      if (element.value) {
        modal.value = new Modal(element.value);
        jobsEventBus.on("workerBusy", eventHandler);
        element.value.addEventListener("hidden.bs.modal", clearState);
      }
    });

    onUnmounted((): void => {
      jobsEventBus.off("workerBusy", eventHandler);
      element.value?.removeEventListener("hidden.bs.modal", clearState);
    });

    return {
      handleBookAnyway,
      toggleModal,
      loading,
      payload
    };
  }
});
